module.exports = __webpack_public_path__ + "media/brikcombi.af478cbb.mp4";